import React from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

export const PromptForUnavailableInTheme = (props?: {
  componentName?: string;
  siteTheme: string;
}): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (isEditing) {
    return (
      <h3>
        This rendering: {props?.componentName} is not available for this theme: {props?.siteTheme}.
      </h3>
    );
  }

  return <></>;
};
